export class FgDamagesRequest{
    fgDamageId:number;
    constructor(fgDamageId:number){
        this.fgDamageId=fgDamageId
    }
}